/**
 * Pick the chrome before the page component loads.
 * Default used to be Broche Members, which flashed on IABF routes
 * while auth + lazy imports ran.
 */
const BROCHE_APP_PREFIXES = [
  '/technique-library',
  '/video',
  '/dancer',
  '/ballet-classes',
  '/class-history',
  '/bookmarks',
  '/watch-history',
  '/class-schedule',
  '/sign-in',
  '/sign-up'
]

export function layoutForPath (path) {
  const p = String(path || '').split('?')[0]
  if (p === '/pointe' || p.startsWith('/pointe/')) {
    return 'pointe-layout'
  }
  for (let i = 0; i < BROCHE_APP_PREFIXES.length; i++) {
    const prefix = BROCHE_APP_PREFIXES[i]
    if (p === prefix || p.startsWith(prefix + '/')) {
      return 'app-layout'
    }
  }
  return 'iabf-layout'
}

export function initialLayout () {
  if (typeof window === 'undefined') {
    return 'iabf-layout'
  }
  return layoutForPath(window.location.pathname)
}
